import React, { useEffect, useState } from "react";
import {
  FormGroup,
  Label,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Input,
} from "reactstrap";

import style from "./DropDowFunds.module.scss";

const DropDownFunds = ({ funds, name, disabled, label, value, empty, onChange, allFunds }) => {
  const getNameFunds = (id) => {
    const name = funds.filter((f) => f.Id === id);
    if (name && name[0]) return name[0].Value;
    else return "All funds";
  };

  useEffect(() => {
    if (empty === undefined && value === 0 && funds[0]) {
      onChange(name, funds[0].Id);
    }
  }, []);

  return (
    <div className={style.filterDropdown}>
      <FormGroup>
        {label && value != "3" && (
          <Label
            style={{
              fontWeight: 500,
              fontSize: "15px",
              display: "block",
              color: "black",
            }}
          >
            Fund
          </Label>
        )}

        {!disabled ? (
          <UncontrolledDropdown
            disabled={disabled}
            style={{ width: "fit-content", marginRight: "10px", height: "fit-content !important" }}
          >
            <DropdownToggle caret color="secondary" className={style.dropdown}>
              {getNameFunds(value)}
            </DropdownToggle>

            <DropdownMenu className={style.menu}>
              {allFunds && (
                <DropdownItem
                  disabled={disabled}
                  onClick={() => onChange(name, -1)}
                  style={{ backgroundColor: value === -1 ? "#97a6ad" : "inherit" }}
                >
                  All funds
                </DropdownItem>
              )}
              {funds.map((key, index) => (
                <DropdownItem
                  disabled={disabled}
                  key={`${key.Id}-${index}`}
                  onClick={() => onChange(name, key.Id)}
                  style={{ backgroundColor: value === key.Id ? "#97a6ad" : "inherit" }}
                >
                  {key.Value}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        ) : (
          value !== "3" && <Input type="text" disabled={disabled} value={getNameFunds(value)}></Input>
        )}
      </FormGroup>
    </div>
  );
};

export default DropDownFunds;
